import React, { Component } from "react";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import * as AppActions from "../../actions";

class Logout extends Component {
  static propTypes = {
    actions: PropTypes.func.isRequired,
    sidebarVisibility: PropTypes.bool.isRequired
  };

  componentDidMount() {
    this.props.actions.resetForms();
    this.props.actions.resetForm();
    this.props.actions.resetFormArray();
    this.props.actions.resetNotifications();
    this.props.actions.resetSentItems();
    this.props.actions.setAuthSession("");
    this.props.actions.logout();
  }

  render() {
    return <div></div>;
  }
}

Logout.propTypes = {
  sidebarVisibility: PropTypes.bool.isRequired,
  actions: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  sidebarVisibility: state.informedWebApp.sidebarVisibility
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(AppActions, dispatch)
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Logout)
);



// WEBPACK FOOTER //
// ./src/containers/Logout/index.js